import camelCase from 'lodash.camelcase';
import isArray from 'lodash.isarray';
import isObject from 'lodash.isobject';
import transform from 'lodash.transform';

/**
 * This recursive function takes an object structure, and returns a deep copy where all property
 * keys have been converted to camelCase.
 */
export const camelize = obj => transform(obj, (acc, value, key, target) => {
  const camelKey = isArray(target) ? key : camelCase(key);

  acc[camelKey] = isObject(value) ? camelize(value) : value;
});
